// extracted by mini-css-extract-plugin
export default {"messageDate":"MessageInfo_messageDate__27y16","author":"MessageInfo_author__L2PFR"};